// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LpAPf","textarea":"styles_textarea__dr-PN"};